import dynamic from 'next/dynamic';
import { SeoReviews } from '~/contracts/common/Seo';
import { Container, Headline, SubHeadline, Wrapper } from './Reviews.styles';

type OwnProps = {
  seoReviews: SeoReviews;
};

const ReviewsCarousel = dynamic(
  () => import(/* webpackChunkName: "ReviewsCarousel" */ './ReviewsCarousel'),
  { ssr: false }
);

export default function Reviews({ seoReviews }: OwnProps) {
  const formattedRating = (
    Math.round(seoReviews.summary.review_average_rating * 10) / 10
  ).toFixed(1);

  return (
    <>
      <Container data-testid="seo-reviews-section">
        <Wrapper>
          <div className="flex flex-col gap-xl">
            <Headline>Used cars reviews</Headline>
            <SubHeadline>
              See what’s behind our {formattedRating}-star average rating.{' '}
            </SubHeadline>
          </div>
          <ReviewsCarousel
            reviews={seoReviews.reviews}
            averageRating={seoReviews.summary.review_average_rating}
          />
        </Wrapper>
      </Container>
      <div className="bg-background-default">
        <div className="mx-2xl max-w-[1272px] border-b border-border-weak md:mx-3xl lg:mx-4xl xl:mx-auto" />
      </div>
    </>
  );
}
